import React from "react";
import { useTranslation } from "react-i18next";

export default function HaGetSessionKey() {
  const { t } = useTranslation("help");

  const pythonCode = `import requests

API_KEY = ""  # ${t("HaGetSessionKey.required", "Required")}
USER_EMAIL = ""  # ${t("HaGetSessionKey.required", "Required")}
USER_PASSWORD = ""  # ${t("HaGetSessionKey.required", "Required")}

url = f"https://demo.whitehax.com/api/auth/session/"

payload = {"email": USER_EMAIL, "password": USER_PASSWORD}

headers = {"Authorization": API_KEY}

response = requests.request("POST", url, headers=headers, data=payload)

print(response.text)`;

  return (
    <div className="endpoint-container">
      <a href="#get-session-key" className="endpoint-title">
        {t("HaGetSessionKey.title", "Get Session Key")}
      </a>

      <pre className="code-block">
        <code>{pythonCode}</code>
      </pre>

      <style>{`
        .endpoint-container {
          width: 100%;
          box-sizing: border-box;
          background: #1f1f1f;
          color: #f5f5f5;
          padding: 20px;
          font-family: Arial, Helvetica, sans-serif;
        }

        .endpoint-title {
          display: inline-block;
          margin-bottom: 26px;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }

        .endpoint-title:hover {
          color: #b7ddf2;
        }

        .code-block {
          margin: 0;
          padding: 0;
          background: transparent;
          color: #d4d4d4;
          font-family: Consolas, "Courier New", monospace;
          font-size: 14px;
          line-height: 1.45;
          white-space: pre-wrap;
          overflow-x: auto;
          tab-size: 4;
        }

        .code-block code {
          font-family: inherit;
        }

        @media (max-width: 768px) {
          .endpoint-title {
            font-size: 15px;
            margin-bottom: 20px;
          }

          .code-block {
            font-size: 13px;
            line-height: 1.45;
          }
        }
      `}</style>
    </div>
  );
}